'use client';

import { light } from '.';
import { breakpoints, isBreakpoint } from './base';
import { themeToVars } from '@mantine/vanilla-extract';

export const vars = themeToVars(light);

/**
 * @returns the value of a breakpoint in pixels
 */
const _getBreakpointValue = (
  bp: keyof typeof breakpoints | number | (string & {}),
) => {
  if (typeof bp === 'number') return `${bp}px`;

  // we must use pixels instead of rems for media queries
  if (isBreakpoint(bp)) return `${parseInt(breakpoints[bp], 10) * 16}px`;

  return bp;
};

/**
 * @returns a media query selector that apply to screens larger than the given value
 * @example ```
 *   style({
 *     '@media': {
 *       [largerThan('md')]: {
 *         color: 'red'
 *       }
 *     }
 *   })```
 */
export const largerThan = (
  bp: keyof typeof breakpoints | number | (string & {}),
) => `not all and (max-width: ${_getBreakpointValue(bp)})`;

/**
 * @returns a media query selector that apply to screens smaller than the given value
 * @example ```
 *   style({
 *     '@media': {
 *       [smallerThan('md')]: {
 *         color: 'red'
 *       }
 *     }
 *   })```
 */
export const smallerThan = (
  bp: keyof typeof breakpoints | number | (string & {}),
) => `(max-width: ${_getBreakpointValue(bp)})`;
